// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9562 ? "3975359d" : chunkId) + "." + {"1369":"44494250c7dfdd43","9562":"2b69605d2c63c58c"}[chunkId] + ".js";
};